import { Controller } from "@hotwired/stimulus"

// Disables the submit button on native (non-Turbo) form submissions, so its
// loading state still shows — Turbo Drive normally does this itself, but
// forms opting out with data-turbo="false" get no such handling for free.
export default class extends Controller {
  submit(event) {
    if (event.defaultPrevented) return // e.g. blocked by form-validation

    const button = event.submitter || this.element.querySelector('button[type="submit"]')
    if (button) button.disabled = true
  }
}
